export const initialBulkInfo = {
  bulkRoomId: null,
  bulkRatePlanId: null,
  bulkDateRanges: [{ startDate: null, endDate: null }],
  bulkAvailability: "",
  bulkRate: "",
  // null = No Change (default). true = Close, false = Open
  bulkCloseout: null,
  // When true, explicitly close out ALL rate plans for the date ranges
  bulkCloseAll: false,
  // When true, explicitly open all rate plans for the date ranges (remove closeouts)
  bulkOpenAll: false,
  bulkMinimumStay: "",
  bulkMaximumStay: "",
  bulkRackRate: "",
};
